import { runFetch } from "../../index"

export const usersApi = (origin, token) => {
  return {
    applications: {
      get: async (email) => {
        const user = await runFetch(`/admin/users/${encodeURIComponent(email)}`, token, origin)
        const { applications } = await runFetch(
          `/admin/users/${user.id}/applications?pageSize=100`,
          token,
          origin
        )

        return applications.map((a) => ({
          key: a.applicationId,
          name: a.applicationName,
          description: a.applicationDescription
        }))
      }
    }
  }
}
